import _JSXStyle from "styled-jsx/style";
import { Input } from '@dhis2-ui/input';
import { spacers, colors } from '@dhis2/ui-constants';
import PropTypes from 'prop-types';
import React from 'react';

const FilterInput = _ref => {
  let {
    value,
    onChange,
    placeholder,
    className,
    dataTest
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: _JSXStyle.dynamic([["730881408", [colors.white, spacers.dp8, spacers.dp8, spacers.dp4, spacers.dp8]]]) + " " + (className || "")
  }, /*#__PURE__*/React.createElement(Input, {
    dense: true,
    dataTest: dataTest,
    value: value,
    onChange: onChange,
    type: "text",
    name: "filter",
    placeholder: placeholder,
    initialFocus: true
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "730881408",
    dynamic: [colors.white, spacers.dp8, spacers.dp8, spacers.dp4, spacers.dp8]
  }, ["div.__jsx-style-dynamic-selector{position:-webkit-sticky;position:sticky;-webkit-inset-block-start:0;-ms-intb-rlock-start:0;inset-block-start:0;background:".concat(colors.white, ";padding-block-start:").concat(spacers.dp8, ";padding-inline-end:").concat(spacers.dp8, ";padding-block-end:").concat(spacers.dp4, ";padding-inline-start:").concat(spacers.dp8, ";z-index:1;}")]));
};

FilterInput.propTypes = {
  dataTest: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func
};
export { FilterInput };